import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, Injectable, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { IPinnedTile, TileService } from '../services/tile.service';
import { Tile, TileComponent } from '../tile/tile.component';
import { ApplicationsService } from '../../applications/services/application.service';
import { QuicklinksComponent } from '../../quicklinks/quicklinks.component';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-tile-container',
  templateUrl: './tile-container.component.html',
  standalone: true,
  imports: [
    TileComponent, CommonModule, DragDropModule
  ],
  styleUrls: ['./tile-container.component.scss']
})
export class TileContainerComponent implements OnInit, OnChanges {
  @Input() tiles: Tile[] = [];
  @Input() size: string = "xlarge";
  @Input() draggable: boolean = true;
  @Input() tileTemplate: TemplateRef<any> | null = null;
  @Input() showAdd: boolean = false;
  @Input() showCatalogue: boolean = false;

  @Output() tilePinnedChange = new EventEmitter<Tile>();
  @Output() sortOrderChanged = new EventEmitter<ITileOrder[]>();
  @Output() addNew = new EventEmitter();
  @Output() showCatalogTile = new EventEmitter();

  pinnedTiles: IPinnedTile[] = [];

  constructor(private service: TileService, private appService: ApplicationsService, private quicklinkComponentService: QuicklinksComponent, private router: Router) {
  }

  async ngOnInit() {
    this.service.getPinnedTiles().then(data => {
      this.pinnedTiles = data;

      if (this.tiles && this.tiles.length > 0 && this.tiles[0].type != "assessment") {
        this.tiles.forEach(tile => {
          tile.ispinned = this.pinnedTiles.some(pinnedTile => pinnedTile.tileId === tile.id);
        });
        if (this.tiles[0].title =='Whiteboards') {
          this.tiles.forEach(tile => {
            tile.ispinned = this.pinnedTiles.some(pinnedTile => pinnedTile.tileId === tile.data.miroId);
          });
        }
      }
    });
  }

  ngOnChanges() {
    if (this.tiles && this.tiles.length > 0 && this.tiles[0].type != "assessment") {
      this.tiles.forEach(tile => {
        tile.ispinned = this.pinnedTiles.some(pinnedTile => pinnedTile.tileId === tile.id);
      });
    }
    if (this.tiles[0].title == 'Whiteboards') {
      this.tiles.forEach(tile => {
        tile.ispinned = this.pinnedTiles.some(pinnedTile => pinnedTile.tileId === tile.data.miroId);
      });
    }

  }
  delay(time: number) {
    return new Promise(resolve => setTimeout(resolve, time));
  }
  pinnedChange(event: Tile) {
    // Just bubble up the event
    this.tilePinnedChange.emit(event);
  }

  drop(event: CdkDragDrop<any>) {
    let oldIndex = event.previousContainer.data.index;
    let newIndex = event.container.data.index;

    if (oldIndex == newIndex) {
      return;
    }

    if (newIndex == 999) {
      newIndex = this.tiles.length;
    }

    if (oldIndex < newIndex) {
      newIndex--;
    }

    this.arraymove(this.tiles, oldIndex, newIndex);

    this.sortOrderChanged.emit(this.getTileOrders());
    if (this.tiles[0].title == "Applications") {

      this.service.OrderTileApplication(this.getTileOrders());
      this.quicklinkComponentService.applications = [];
      this.quicklinkComponentService.applicationsDD = [];
      this.quicklinkComponentService.applicationsMain = [];
      //this.delay(300).then(() => this.quicklinkComponentService.retrieveApplications());
    }

    else if (this.tiles[0].title == "Ask The Experts")
      this.service.OrderTileExpert(this.getTileOrders());
    else
      this.service.OrderTileTaskList(this.getTileOrders());
  }

  getTileOrders(): any {
    let tileOrders: ITileOrder[] = [];

    for (var i = 0; i < this.tiles.length; i++) {
      tileOrders.push({ id: this.tiles[i].id, order: i });
    }

    return tileOrders;
  }

  arraymove(arr: any[], fromIndex: number, toIndex: number) {
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
  }

  addClick() {
    this.addNew.emit();
  }
  showCatalogueClick() {
    this.showCatalogTile.emit();
  }
}

export interface ITileOrder {
  id: string;
  order: number;
}


